import BaseStyle from 'primevue/base/style';

var classes = {
  root: 'p-breadcrumb p-component',
  menu: 'p-breadcrumb-list',
  home: 'p-breadcrumb-home',
  separator: 'p-menuitem-separator',
  menuitem: function menuitem(_ref) {
    var instance = _ref.instance;
    return ['p-menuitem', {
      'p-disabled': instance.disabled()
    }];
  },
  action: 'p-menuitem-link',
  icon: 'p-menuitem-icon',
  label: 'p-menuitem-text'
};
var BreadcrumbStyle = BaseStyle.extend({
  name: 'breadcrumb',
  classes: classes
});

export { BreadcrumbStyle as default };
